import { createContext, useContext, useState, useCallback } from 'react'
import zhTW from './zh-TW.json'
import en from './en.json'

const languages = { 'zh-TW': zhTW, en }

const I18nContext = createContext()

export const I18nProvider = ({ children }) => {
  const [locale, setLocale] = useState(() => {
    return localStorage.getItem('hrms_locale') || 'zh-TW'
  })

  const switchLocale = useCallback((newLocale) => {
    if (languages[newLocale]) {
      setLocale(newLocale)
      localStorage.setItem('hrms_locale', newLocale)
    }
  }, [])

  const t = useCallback((key) => {
    const keys = key.split('.')
    let value = languages[locale]
    for (const k of keys) {
      value = value?.[k]
      if (value === undefined) break
    }
    // Fallback to zh-TW, then to key itself
    if (value === undefined) {
      value = languages['zh-TW']
      for (const k of keys) {
        value = value?.[k]
        if (value === undefined) break
      }
    }
    return value ?? key
  }, [locale])

  return (
    <I18nContext.Provider value={{ locale, setLocale: switchLocale, t, availableLocales: Object.keys(languages) }}>
      {children}
    </I18nContext.Provider>
  )
}

export const useI18n = () => {
  const context = useContext(I18nContext)
  if (!context) throw new Error('useI18n must be used within I18nProvider')
  return context
}

export default I18nContext
